import { gql } from '@apollo/client';

export const GET_MY_SESSIONS_QUERY = gql`
  query GetMySessions {
    getMySessions {
      createdAt
      current
      deviceName
      expiresAt
      id
      kind
      lastUsedAt
      userAgent
    }
  }
`;
